import config from "config/config";
import moment from "moment-timezone";
import { isAgentPortal, isFlagEnabled } from "js/utilities";
import { useEffect, useState } from "react";
import { getChatStatus } from "service/chat";

export default function useIsChatOnline(openChatWindow) {
  const [chatStatus, setChatStatus] = useState(true);

  useEffect(() => {
    const configChatStatus = async () => {
      await getChatStatus(isAgentPortal() ? "agent" : "customer")
        .then((res) => {
          setChatStatus(res);
        })
        .catch(() => {
          setChatStatus(false);
        });
    };

    if (isFlagEnabled("ENABLE_MANUAL_CHAT_TIME")) {
      configChatStatus();
    } else {
      if (config.ENV === "QA") {
        // set chat available time from 2PM - 10PM IST for offshore QAs
        const currentDate = moment().tz("Asia/Kolkata").weekday();
        const currentHour = moment().tz("Asia/Kolkata").hour();

        if (currentDate >= 1 && currentDate <= 5) {
          if (currentHour >= 14 && currentHour <= 21) {
            setChatStatus(true);
          } else {
            setChatStatus(false);
          }
        } else if (currentDate === 6) {
          if (currentHour >= 14 && currentHour <= 21) {
            setChatStatus(true);
          } else {
            setChatStatus(false);
          }
        } else {
          setChatStatus(false);
        }
      } else {
        const currentDate = moment().tz("America/Chicago").weekday();
        const currentHour = moment().tz("America/Chicago").hour();

        if (currentDate >= 1 && currentDate <= 5) {
          if (currentHour >= 8 && currentHour <= 17) {
            setChatStatus(true);
          } else {
            setChatStatus(false);
          }
        } else if (currentDate === 6) {
          if (currentHour >= 9 && currentHour <= 12) {
            setChatStatus(true);
          } else {
            setChatStatus(false);
          }
        } else {
          setChatStatus(false);
        }
      }
    }
  }, [openChatWindow]);

  return chatStatus;
}
